import { useEffect, useRef, useCallback } from 'react';
import { STORAGE_KEY, NAME_STORAGE_KEY } from '@/constants/editor';


export function useAutoSave(
  paperProject,
  syncItemsFromPaper,
  drawGrid,
  projectName,
  setProjectName
) {
  const isInitialLoadRef = useRef(true);


  const removeSystemItems = (project) => {
    if (!project) return;

    const systemNames = ['grid', 'transformOverlay', 'glassArea'];
    systemNames.forEach((name) => {
      const item = project.getItem({ name });
      if (item) item.remove();
    });

    project.getItems({ guide: true }).forEach((item) => item.remove());
  };


  useEffect(() => {
    if (!paperProject || !paperProject.view || !isInitialLoadRef.current) return;

    const restoreProject = () => {
      try {

        const savedName = localStorage.getItem(NAME_STORAGE_KEY);
        if (savedName && typeof setProjectName === 'function') {
          setProjectName(savedName);
        }


        const savedProject = localStorage.getItem(STORAGE_KEY);
        if (savedProject) {
          paperProject.clear();
          paperProject.importJSON(savedProject);
          removeSystemItems(paperProject);

          if (typeof drawGrid === 'function') {
            drawGrid();
          }

          paperProject.view.update();
          syncItemsFromPaper();
        }
      } catch (error) {
        console.error('Помилка відновлення проекту з LocalStorage:', error);
      } finally {
        isInitialLoadRef.current = false;
      }
    };

    const animationFrameId = requestAnimationFrame(restoreProject);
    return () => cancelAnimationFrame(animationFrameId);
  }, [paperProject, syncItemsFromPaper, drawGrid, setProjectName]);

  const saveToLocalStorage = useCallback(() => {
    if (!paperProject || isInitialLoadRef.current) return;
    try {

      if (projectName) {
        localStorage.setItem(NAME_STORAGE_KEY, projectName);
      }

      const gridItem = paperProject.getItem({ name: 'grid' });
      if (gridItem) {
        gridItem.remove();
      }

      const jsonState = paperProject.exportJSON();
      localStorage.setItem(STORAGE_KEY, jsonState);

      if (typeof drawGrid === 'function') {
        drawGrid();
      }
    } catch (error) {
      console.error('Помилка автозбереження у LocalStorage:', error);
    }
  }, [paperProject, projectName, drawGrid]);

  useEffect(() => {
    if (!isInitialLoadRef.current && projectName) {
      localStorage.setItem(NAME_STORAGE_KEY, projectName);
    }
  }, [projectName]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      saveToLocalStorage();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [saveToLocalStorage]);

  return {
    saveToLocalStorage,
    clearAutoSave: () => {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(NAME_STORAGE_KEY);
    },
  };
}